<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <div v-if="success" class="card success-card">
          <div class="card-body green">You successfully edited this device!</div>
        </div>
      </b-col>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Edit Device</strong>
          </div>
          <b-form @submit.prevent="editDevice">
          <b-form-group
            label="Company"
            label-for="basicSelect">
            <b-form-select id="basicSelect"
              v-model="companyId"
              v-validate="'required'"
              :plain="true"
              :options="options"
              value="Please select"
              name="company_id"
              :class="{'has-error': errors.has('company_id')}"
              ></b-form-select>
              <span class="red">{{ errors.first('company_id') }}</span>
          </b-form-group>
          <b-form-group
            description="The device name displayed publicy to the user on the mobile app."
            label="Device Name">
            <b-form-input
              v-model="name"
              type="text"
              v-validate="'required'"
              placeholder="Enter device name"
              name="device_name"
              :class="{'has-error': errors.has('device_name')}"
            ></b-form-input>
            <span class="red">{{ errors.first('device_name') }}</span>
          </b-form-group>
          <b-form-group
            description="The unique internal device id."
            label="Device ID">
            <b-form-input
              v-model="id"
              v-if="admin.level === 0"
              type="text"
              v-validate="'required'"
              placeholder="Enter device id"
              name="device_id"
              :class="{'has-error': errors.has('device_id')}"
            ></b-form-input>
            <span class="red">{{ errors.first('device_id') }}</span>
            <span class="label-text" v-if="admin.level > 0">{{id}}</span>
          </b-form-group>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label for="streetAddress">Street Address</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="streetAddress"
                  placeholder="Enter street address"
                  name="street_address"
                  :class="{'has-error': errors.has('street_address')}"
                ></b-form-input>
                <span class="red">{{ errors.first('street_address') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="city">City</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="city"
                  id="city"
                  placeholder="Enter your city"
                  name="city"
                  :class="{'has-error': errors.has('city')}"
                ></b-form-input>
                <span class="red">{{ errors.first('city') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label="Province / State"
                label-for="selectProvinceState">
                <b-form-select id="selectProvinceState"
                  v-model="province"
                  v-validate="'required'"
                  :plain="true"
                  :options="stateProvince"
                  value="Please select"
                  name="state_province"
                  :class="{'has-error': errors.has('state_province')}"
                >
                </b-form-select>
                <span class="red">{{ errors.first('state_province') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="postal-code">Postal / Zip Code</label>
                <b-form-input
                  type="text"
                  v-validate="'required'"
                  v-model="postalCode"
                  id="postal-code"
                  placeholder="Postal / Zip Code"
                  name="postal_code"
                  :class="{'has-error': errors.has('postal_code')}"
                ></b-form-input>
                <span class="red">{{ errors.first('postal_code') }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="form-actions">
            <b-button type="submit" name="submit" variant="primary">Submit</b-button>
          </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import axios from 'axios'
import getAdmin from '../../mixins/getAdmin'
import Loading from 'vue-loading-overlay'
import stateProvince from '../../stateProvince'

export default {
  name: 'RegisterDevice',
  mixins: [
    getAdmin
  ],
  components: {
    Loading
  },
  data () {
    return {
      admin: {},
      city: '',
      companyId: 0,
      id: '',
      name: '',
      options: [],
      postalCode: '',
      province: '',
      stateProvince,
      streetAddress: '',
      success: false
    }
  },
  computed: {
    ...mapGetters([
      'isLoading'
    ])
  },
  methods: {
    /**
     * Submits the form information to the backend API once submit button is pressed. The information is passed through a validator to make sure they meet the required details.
     */
    editDevice: function () {
      let self = this
      const { id, name, companyId, streetAddress, city, postalCode, province } = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put(`${process.env.VUE_APP_API_URL}api/devices/${this.$route.params.id}`, {
            device_name: name,
            name: id,
            company_id: companyId,
            street_address: streetAddress,
            city: city,
            postal_code: postalCode,
            province: province
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.success = true
              window.scrollTo(0, 0)
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    },
    /**
     * Gets all companies registered under this organization in order to populate the companies select dropdown field.
     */
    getCompanies: function () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/companies${(this.admin.level === 0 ? '/all' : '')}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let companies = []
          let data = response.data.data

          for (let i = 0; i < data.length; i++) {
            companies.push({
              value: data[i]['company_id'],
              text: data[i]['name']
            })
          }

          self.options = companies
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    /**
     * Queries device by id from backend API to get current device details in order to auto populate edit form.
     */
    getDeviceDetails: function () {
      let self = this

      axios.get(`${process.env.VUE_APP_API_URL}api/devices/${this.$route.params.id}${(this.admin.level === 0 ? '/all' : '')}`, {
        headers: {
          'x-access-token': localStorage.getItem('user-token')
        }
      })
        .then(function (response) {
          let data = response.data.data

          self.companyId = data.company_id
          self.id = data.name
          self.name = data.device_name
          self.streetAddress = data.street_address
          self.city = data.city
          self.postalCode = data.postal_code
          self.province = data.province
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  async mounted () {
    this.$store.commit('updateIsLoading', true)

    await this.getAdmin()
    await this.getCompanies()
    await this.getDeviceDetails()

    self.$store.commit('updateIsLoading', false)
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.label-text {
  color: #73818F;
}
</style>
